'use strict';
/**
 * @directive sgHtmlAttribures
 * Directive can be used to add custom HTML attributes to an element.
 * By using this directive we can keep form factories/directives as generic as possible.
 *
 * @example <div sg-html-attributes="[{class: 'foo foo__var', maxlength: 10}]"/>
 * */

(function () {
  angular.module('specsguardApp')
    .directive('sgHtmlAttributes', sgHtmlAttributes);

  sgHtmlAttributes.$inject = ['$compile'];

  function sgHtmlAttributes ($compile) {
    return {
      link: function (scope, element, attrs) {
        // Proper way of including HTML attributes
        const attributeCollections = scope.$eval(attrs.sgHtmlAttributes);

        for (const attribute in attributeCollections)  {
          if (attributeCollections.hasOwnProperty(attribute)) {
            attrs.$set(attribute, attributeCollections[attribute]);
          }
        }

        element.removeAttr('sg-html-attributes');

        $compile(attrs);

      }
    };
  }
})();
